import React, { useEffect, useState } from "react";
import subVisualBoard from "../../assets/subVisual/subVisualBoard.webp";
import Icon from "../../components/Icon";
import SubVisual from "../../components/SubVisual";
import { boardLists } from "../../data/board";
import mainContentsArrowLeftIcon from "../../assets/images/home/mainContentsArrowLeft.png";
import mainContentsArrowRightIcon from "../../assets/images/home/mainContentsArrowRight.png";
import * as S from "./styled";
import { NavLink } from "react-router-dom";
import Aos from "aos";
import { Helmet } from "react-helmet-async";

const itemsPerPage = 6; // 한 페이지당 보여줄 아이템 개수

const Board = () => {
  const [currentPage, setCurrentPage] = useState(1);

  // 전체 페이지 수 계산
  const totalPages = Math.ceil(boardLists.length / itemsPerPage);

  // 현재 페이지의 데이터 가져오기
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = boardLists.slice(startIndex, endIndex);

  // 페이지 변경 핸들러
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      Aos.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>IPDIA 국제실용댄스지도자협회</title>

        <meta
          name="description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />

        <meta
          name="keywords"
          content="IPDIA, 아이피디아, 국제실용댄스지도자협회, 국제실용댄스, 셔플댄스, 댄스협회, 댄스자격증, 실용무용, 댄스강사자격증"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ipdiakorea.com" />
        <meta
          property="og:image"
          content="https://ipdiakorea.com/og-image.png"
        />
      </Helmet>
      <S.BoardContainer>
        <SubVisual
          src={subVisualBoard}
          title="협회 활동"
          subTitle="협회 소식"
        />
        <S.BoardWrapper>
          <div className="inner">
            <S.BoardWrap>
              <S.BoardListWrapper>
                {currentItems.map((list, index) => {
                  return (
                    <li
                      key={list.id}
                      data-aos="fade-up"
                      data-aos-duration={700}
                      data-aos-delay={(index + 1) * 150}
                      data-aos-easing="linear"
                    >
                      <NavLink to={`/board/${list.id}`}>
                        <div className="img-wrap">
                          <Icon>
                            <img src={list.thumb} alt="logo" />
                          </Icon>
                        </div>
                        <div className="text-wrap">
                          <h4>{list.title}</h4>
                          <p>{list.listText}</p>
                          <span>{list.date}</span>
                        </div>
                      </NavLink>
                    </li>
                  );
                })}
              </S.BoardListWrapper>

              {/* 페이지네이션 UI */}
              {boardLists.length > 6 && (
                <S.Pagination
                  data-aos="fade"
                  data-aos-duration={600}
                  data-aos-easing="linear"
                >
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`${currentPage === 1 ? "disabled" : ""}`}
                  >
                    <Icon>
                      <img src={mainContentsArrowLeftIcon} alt="logo" />
                    </Icon>
                  </button>

                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      className={currentPage === index + 1 ? "active" : ""}
                    >
                      {index + 1}
                    </button>
                  ))}

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <Icon>
                      <img src={mainContentsArrowRightIcon} alt="logo" />
                    </Icon>
                  </button>
                </S.Pagination>
              )}
            </S.BoardWrap>
          </div>
        </S.BoardWrapper>
      </S.BoardContainer>
    </>
  );
};

export default Board;
